<div class="flex h-full w-full overflow-hidden bg-neutral-1 text-neutral-12">
  <!-- Left Column: Discussions Sidebar -->
  <etxe-discussion-sidebar
    [discussions]="discussions()"
    [activeDiscussion]="activeDiscussion()"
    [isLoading]="isLoadingDiscussions()"
    [timeFormat]="timeFormat()"
    (discussionSelected)="selectDiscussion($event)"
    (markAsUnread)="markAsUnread($event.discussion, $event.event)"
    (toggleStar)="toggleStar($event.discussion, $event.event)"
    (archiveDiscussion)="archiveDiscussion($event.discussion, $event.event)"
    (filterTabChanged)="onFilterTabChanged($event)"
    (scrolledToBottom)="loadMoreDiscussions()"
  ></etxe-discussion-sidebar>

  <!-- Center Column: Messages Feed -->
  <etxe-discussion-chat
    #chatFeed
    class="flex-1 flex flex-col min-w-0 min-h-0"
    [activeDiscussion]="activeDiscussion()"
    [decoratedMessages]="decoratedMessages()"
    [isLoadingMessages]="isLoadingMessages()"
    [isLoadingMore]="isLoadingMore()"
    [timeFormat]="timeFormat()"
    [pinnedMessage]="activePinnedMessage()"
    [appointment]="currentAppointment()"
    [application]="currentApplication()"
    [isOwner]="isOwner()"
    [property]="propertyContext()"
    (actionClick)="handleChatAction($event)"
    (sendMessage)="sendMessage($event)"
    (copyMessageText)="copyMessageText($event)"
    (pinMessage)="pinMessage($event)"
    (infoMessage)="infoMessage($event)"
    (deleteMessage)="deleteMessage($event)"
    (scrolledToTop)="loadMoreMessages()"
    (readActiveDiscussion)="markActiveDiscussionAsRead()"
    (unpinMessage)="unpinActiveMessage()"
    (retryMessage)="retryMessage($event)"
  ></etxe-discussion-chat>

  <!-- Right Column: Property Context Sidebar -->
  @if (activeDiscussion() && propertyContext()) {
    <etxe-discussion-property-sidebar
      [property]="propertyContext()!"
      [activeDiscussion]="activeDiscussion()"
      [isOwner]="isOwner()"
      [appointment]="currentAppointment()"
      [application]="currentApplication()"
      (openVisitModal)="openVisitModal()"
      (proposeVisit)="openVisitInvitationDialog()"
      (confirmSlot)="confirmVisitSlot($event)"
      (requestReschedule)="requestRescheduleVisit($event)"
      (adjustFinalOffer)="openFinalOfferDialog()"
    ></etxe-discussion-property-sidebar>
  }
</div>
